export const text = {
  CLOSE: 'Close',
  DELETE: 'Delete',
}
